import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Ticket, Star, LinkIcon, ShoppingBasket, Link2, Mail } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface MarketingCard {
  icon: LucideIcon;
  titleKey: string;
  descKey: string;
  path: string;
}

const CARDS: MarketingCard[] = [
  { icon: Ticket, titleKey: 'sidebar.coupons', descKey: 'marketing.couponsDesc', path: '/coupons' },
  { icon: Star, titleKey: 'sidebar.reviews', descKey: 'marketing.reviewsDesc', path: '/reviews' },
  { icon: LinkIcon, titleKey: 'sidebar.analyticalLinks', descKey: 'marketing.analyticalLinksDesc', path: '/analytical-links' },
  { icon: ShoppingBasket, titleKey: 'sidebar.carts', descKey: 'marketing.cartsDesc', path: '/carts' },
  { icon: Link2, titleKey: 'sidebar.paylinks', descKey: 'marketing.paylinksDesc', path: '/paylinks' },
  { icon: Mail, titleKey: 'sidebar.newsletter', descKey: 'marketing.newsletterDesc', path: '/newsletter' },
];

export function MarketingPage() {
  const { storeId } = useParams<{ storeId: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div>
      <h1 className="text-xl font-bold mb-6">{t('sidebar.marketing')}</h1>
      <div className="grid gap-4 sm:grid-cols-2">
        {CARDS.map((card) => (
          <button
            key={card.path}
            onClick={() => navigate(`/${storeId}${card.path}`)}
            className="flex items-start gap-4 rounded-xl border border-border-default bg-bg-secondary p-5 text-start transition-colors hover:border-accent/30 hover:bg-bg-hover"
          >
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent/10 text-accent">
              <card.icon className="h-5 w-5" />
            </div>
            <div>
              <p className="font-semibold text-sm">{t(card.titleKey)}</p>
              <p className="text-xs text-text-muted mt-1">{t(card.descKey)}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
